export { default as resetPassword } from './templates/reset-password'
export { default as deleteAccount } from './templates/delete-account'
export { default as confirmEmail } from './templates/confirm-email'
export { default as updateEmail } from './templates/update-email'
export { default as plcOperation } from './templates/plc-operation'
